import React from 'react';
import * as LucideIcons from 'lucide-react';

// Map of common furniture icon names to Lucide icon names
const ICON_MAP = {
  // Furniture types
  'desk': 'Monitor',
  'bureau': 'Monitor',
  'chair': 'Armchair',
  'chaise': 'Armchair',
  'armchair': 'Armchair',
  'fauteuil': 'Armchair',
  'cabinet': 'Archive',
  'armoire': 'Archive',
  'archive': 'Archive',
  'drawer': 'Package',
  'caisson': 'SquareStack',
  'box': 'Box',
  'shelf': 'Library',
  'etagere': 'Library',
  'table': 'Table2',
  'table_reunion': 'Users',
  'meeting': 'Users',
  'partition': 'PanelLeftClose',
  'cloison': 'PanelLeftClose',
  'monitor': 'Monitor',
  'screen': 'Monitor',
  'computer': 'Monitor',
  'package': 'Package',
  'autre': 'Package',
  'other': 'Package',
  // Generic icons
  'default': 'Package',
};

// Convert kebab-case or snake_case to PascalCase
const toPascalCase = (str) => {
  return str
    .split(/[-_]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
};

const DynamicIcon = ({ name, className = "w-5 h-5", fallback = "Package" }) => {
  if (!name) {
    const FallbackIcon = LucideIcons[fallback] || LucideIcons.Package;
    return <FallbackIcon className={className} />;
  }

  // Try to find icon in our custom map first
  const mappedName = ICON_MAP[name.toLowerCase()];
  if (mappedName) {
    const MappedIcon = LucideIcons[mappedName];
    if (MappedIcon) {
      return <MappedIcon className={className} />;
    }
  }

  // Try direct Lucide icon name (PascalCase)
  const pascalName = toPascalCase(name);
  const DirectIcon = LucideIcons[pascalName];
  if (DirectIcon) {
    return <DirectIcon className={className} />;
  }

  // Try with first letter capitalized
  const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
  const CapitalizedIcon = LucideIcons[capitalizedName];
  if (CapitalizedIcon) {
    return <CapitalizedIcon className={className} />;
  }

  // Fallback to default icon
  const FallbackIcon = LucideIcons[fallback] || LucideIcons.Package;
  return <FallbackIcon className={className} />;
};

export default DynamicIcon;
